//import {extendObservable, action} from 'mobx';
import {localStored, sessionStored} from 'mobx-stored';
import moment from 'moment'

const defaultSearchStore = {
  // state
  pickedPlace: {city:'', country:''},
  rangeDate: {startDate:null, endDate:null},
  selectedOption: null,
}

const SearchStore = sessionStored('searchStore', defaultSearchStore) 

export default SearchStore;


// WEBPACK FOOTER //
// src/mobx-store/search-store.js